import { V2EnergyUnitSubordinateCostPostResponse } from '@maxtropy/device-customer-apis-v2';
import { isEmpty } from 'lodash-es';
import { Themes } from '@maxtropy/components';
import { DateType } from '../../prop';
import { formatThousandUnit } from '@/utils/utils';

const colors = [
  'var(--mx-diagram6-color)',
  'var(--mx-diagram1-color)',
  'var(--mx-diagram2-color)',
  'var(--mx-diagram3-color)',
  'var(--mx-diagram4-color)',
  'var(--mx-diagram5-color)',
  'var(--mx-diagram7-color)',
  'var(--mx-diagram8-color)',
  'var(--mx-diagram9-color)',
  'var(--mx-diagram10-color)',
  'var(--mx-diagram16-color)',
  'var(--mx-diagram1-color)',
  'var(--mx-diagram2-color)',
  'var(--mx-diagram3-color)',
  'var(--mx-diagram4-color)',
  'var(--mx-diagram5-color)',
  'var(--mx-diagram7-color)',
  'var(--mx-diagram8-color)',
  'var(--mx-diagram9-color)',
  'var(--mx-diagram10-color)',
  'var(--mx-diagram16-color)',
];

const momTitleFunc = (timeResolution: DateType) => {
  switch (timeResolution) {
    case DateType.DAY:
      return '环比昨日';
    case DateType.WEEK:
      return '环比上周';
    case DateType.MONTH:
      return '环比上月';
    case DateType.YEAR:
      return '环比上年';
    default:
      return '环比';
  }
};

interface SeriesData {
  name: string;
  value: string;
  momValue?: string;
  yoyValue?: string;
}

export const getOption = (
  data: V2EnergyUnitSubordinateCostPostResponse['list'],
  timeResolution: DateType,
  theme: Themes
) => {
  if (isEmpty(data)) return;

  const mainData: SeriesData[] = [];
  const subData: SeriesData[][] = [];

  data!.forEach((item, index) => {
    mainData.push({
      name: item.unitName!,
      value: item.cost!,
      momValue: item.momValue,
      yoyValue: item.yoyValue,
    });
    (item.chartList ?? []).forEach((d, dix) => {
      subData[dix] = [
        ...(subData[dix] ?? []),
        {
          name: d.unitName!,
          value: d.cost!,
          momValue: d.momValue,
          yoyValue: d.yoyValue,
        },
      ];
    });
  });
  console.log('subData', subData);
  const isShowYoy = timeResolution === DateType.WEEK || timeResolution === DateType.MONTH;

  return {
    grid: {
      top: 80,
      bottom: 20,
      containLabel: true,
    },
    color: colors,
    legend: {
      right: 10,
      top: 10,
      itemWidth: 12,
      itemHeight: 12,
      type: 'scroll',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params: any) => {
        return `
          <div style="font-size:12px;">
            <div>${params[0]?.axisValue}</div>
            <table>
              <tr style="text-align: right;">
                <td style="padding: 0 8px"></td>
                <td style="padding: 0 8px">成本</td>
                <td style="padding: 0 8px">${momTitleFunc(timeResolution)}</td>
                ${isShowYoy ? `<td style="padding: 0 8px">同比上年</td>` : ''}
              </tr>
              ${params
                .map((item: any) => {
                  const { marker, data } = item;
                  const { momValue, name, value, yoyValue } = data ?? {};
                  return `
                  <tr style="text-align: right;">
                    <td style="padding: 0 8px;text-align: left;">${marker}${name}</td>
                    <td style="padding: 0 8px;color: ${
                      theme === Themes.DARK ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.85)'
                    }">
                      ${formatThousandUnit(value)}元
                    </td>
                    <td style="padding: 0 8px;color:${Number(momValue ?? 0) > 0 ? '#E64242' : '#52C41A'}">
                      ${momValue ?? '--'}%
                    </td>
                    ${
                      isShowYoy
                        ? `<td style="padding: 0 8px;color:${Number(yoyValue ?? 0) > 0 ? '#E64242' : '#52C41A'}">
                        ${yoyValue ?? '--'}%</td>`
                        : ''
                    }
                  </tr>
                `;
                })
                .join('')}
            </table>
          </div>
        `;
      },
    },
    xAxis: {
      type: 'category',
      data: data?.map(i => i.time),
      textStyle: {
        color: 'var(--mx-text-secondary-color)',
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: 'var(--mx-text-secondary-color)',
        },
        formatter: (name: string) => name.split('（')[0],
      },
    },
    yAxis: {
      type: 'value',
      name: '元',
      nameGap: 30,
    },
    series: [
      {
        name: `${mainData[0]?.name}`,
        type: 'bar',
        barMaxWidth: 80,
        emphasis: {
          focus: 'series',
        },
        data: mainData,
      },
      ...(subData?.map(item => ({
        name: `${item[0]?.name}`,
        type: 'bar',
        emphasis: {
          focus: 'series',
        },
        stack: 'sub',
        barMaxWidth: 80,
        data: item,
      })) ?? []),
    ],
  };
};
